module.exports = __webpack_public_path__ + "static/googlepay-logo-small-9b4b89eb62e70b6b896b5c9fc4c8de92.svg";